import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionsTypeStored: null, // or set a default value if needed
};

const sessionTypeSlice = createSlice({
  name: 'sessionType',
  initialState,
  reducers: {
    setSessionType: (state, action) => {
      state.sessionsTypeStored = action.payload; // Update the session type
    },
    clearSessionType: (state) => {
      state.sessionsTypeStored = null; // Clear the session type
    },
  },
});

// Export the actions to be used in components
export const { setSessionType, clearSessionType } = sessionTypeSlice.actions;

// Export the reducer to be included in the store
export default sessionTypeSlice.reducer;
